/**
 * Where the installable builds live.
 *
 * Cloud Storage rather than the hosting bundle: the Mac disk image is ~130 MB
 * and shipping it with every deploy of the site would make each one minutes
 * long. Shared by the landing page and by Settings so the two never drift.
 */
const BASE = 'https://firebasestorage.googleapis.com/v0/b/monotes-21735.firebasestorage.app/o'

/** `alt=media` matters: without it the URL returns JSON metadata, not the file. */
const file = (name: string) => `${BASE}/downloads%2F${encodeURIComponent(name)}?alt=media`

export interface Download {
  platform: string
  label: string
  note: string
  url: string
}

export const DOWNLOADS: Download[] = [
  {
    platform: 'macOS',
    label: 'Download for Mac',
    note: 'Apple silicon · .dmg',
    url: file('Indigo-Notes-mac-arm64.dmg'),
  },
  {
    platform: 'Windows',
    label: 'Download for Windows',
    note: 'Windows 10 and newer · installer',
    url: file('Indigo-Notes-Setup.exe'),
  },
  {
    platform: 'Android',
    label: 'Download the APK',
    note: 'Sideload · .apk',
    url: file('Indigo-Notes-android.apk'),
  },
]

/**
 * What each platform asks the first time, since none of these come from a
 * store. Worth saying up front: on a Mac the warning reads like the app is
 * broken, and people throw it away instead of opening it.
 */
export const FIRST_RUN_NOTE =
  'None of these come from an app store, so each device asks once. On a Mac, right-click ' +
  'the app in Applications and choose Open the first time. On Windows, unzip anywhere and ' +
  'run the installer — SmartScreen will offer “More info → Run anyway”. On Android, ' +
  'allow installs from your browser when prompted.'
